export const GET_SERVICES_LOADING = "GET_SERVICES_LOADING";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";
